import { request } from '@/utils/request'
// 获取消息列表接口
export const genUserSign = (userId) => {
  return request({
    url: `/cent-talkback/talkCent/genUserSig?userId=${userId}`,
    method: 'get'
  })
}